module.exports = __webpack_public_path__ + "static/media/default-crest.720efbdc.svg";